import { useState, useEffect } from "react";

const useStockValidation = (productId) => {
    const [isOutOfStock, setIsOutOfStock] = useState(false);
    const [loading, setLoading] = useState(false);
    const [stockQuantity, setStockQuantity] = useState(0);

    const validateStock = async (quantity) => {
        try {
            setLoading(true);
            const response = await fetch(`${process.env.BASE_URL}/product/check-stock/${productId}`);
            const data = await response.json();

            setStockQuantity(data.stock_quantity || 0);

            if (data.success && quantity <= data.stock_quantity) {
                setIsOutOfStock(false); // Hay stock suficiente
                return data.stock_quantity;
            } else {
                setIsOutOfStock(true); // No hay stock suficiente
                return data.stock_quantity;
            }
        } catch (error) {
            console.error("Error al validar el stock:", error);
            setIsOutOfStock(true); // Asumimos sin stock si hay un error
            return 0;
        } finally {
            setLoading(false);
        }
    };

    return { isOutOfStock, validateStock, loading, stockQuantity };
};

export default useStockValidation;
